<div class="pane-builder" vid="10">

    <div class="header-top" vid="11">
        <h1 class="serif-title" vid="12">New Route</h1>
        <div class="btn-secondary" vid="13">
            <svg class="icon" viewBox="0 0 24 24" vid="14">
                <path
                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
                    vid="15"></path>
                <circle cx="12" cy="12" r="3" vid="16"></circle>
            </svg>
        </div>
    </div>

    <div class="form-section" vid="17">
        <h2 vid="18">Route Details</h2>
        <div class="form-grid" vid="19">
            <div class="form-group" vid="20">
                <label vid="21">Route Name</label>
                <input type="text" placeholder="e.g., Downtown Morning Run" vid="22" [(ngModel)]="route.name">
            </div>
            <div class="form-group" vid="23">
                <label vid="24">Assigned Driver</label>
                <select vid="25">
                    <option vid="26">Select Driver...</option>
                    <option vid="27">Marcus J.</option>
                    <option vid="28">Sarah L.</option>
                </select>
            </div>
            <div class="form-group full" vid="29">
                <label vid="30">Date</label>
                <input type="date" value="2025-01-14" vid="31">
            </div>
        </div>
    </div>

    <div class="form-section" style="border-color: var(--text-dark);" vid="32">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;" vid="33">
            <h2 vid="34">Add New Stop</h2>
            <button class="btn-secondary" vid="35" (click)="loadFromOrders()">
                <svg class="icon" viewBox="0 0 24 24" vid="36">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" vid="37"></path>
                    <polyline points="17 8 12 3 7 8" vid="38"></polyline>
                    <line x1="12" y1="3" x2="12" y2="15" vid="39"></line>
                </svg>
                Load from Order
            </button>
        </div>

        <!-- Order Selection Panel -->
        <div class="order-selection-panel"
            style="background: var(--input-bg); border: 1px solid var(--border-color); border-radius: var(--radius-md); padding: 16px; margin-bottom: 20px; display: none;"
            vid="40">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;"
                vid="41">
                <label style="margin: 0; font-size: 0.8rem;" vid="42">Select Order to Import</label>
                <button class="btn-secondary" style="padding: 6px 12px; font-size: 0.75rem;" vid="43">Close</button>
            </div>
            <select style="margin-bottom: 12px; width: 100%;" vid="44">
                <option vid="45">Search orders...</option>
                <option vid="46">#ORD-2025-001 - Artemis Cafe</option>
                <option vid="47">#ORD-2025-002 - TechCorp HQ</option>
                <option vid="48">#ORD-2025-003 - J. Smith Residence</option>
                <option vid="49">#ORD-2025-004 - Metro Logistics</option>
            </select>

            <div style="border-top: 1px solid var(--border-color); padding-top: 12px;" vid="50">
                <label style="font-size: 0.75rem; margin-bottom: 8px; display: block;" vid="51">Select Items to
                    Include</label>
                <div style="display: flex; flex-direction: column; gap: 8px;" vid="52">
                    <label
                        style="display: flex; align-items: center; gap: 10px; font-size: 0.9rem; font-weight: 400; text-transform: none; cursor: pointer; padding: 8px; border-radius: var(--radius-sm); background: var(--surface-dark);"
                        vid="53">
                        <input type="checkbox" checked=""
                            style="width: 16px; height: 16px; accent-color: var(--accent-red);" vid="54">
                        <span style="flex: 1;" vid="55">2x Supply Crates - Medium</span>
                        <span class="tag" vid="56">Fragile</span>
                    </label>
                    <label
                        style="display: flex; align-items: center; gap: 10px; font-size: 0.9rem; font-weight: 400; text-transform: none; cursor: pointer; padding: 8px; border-radius: var(--radius-sm); background: var(--surface-dark);"
                        vid="57">
                        <input type="checkbox" checked=""
                            style="width: 16px; height: 16px; accent-color: var(--accent-red);" vid="58">
                        <span style="flex: 1;" vid="59">1x Dairy Box - Perishable</span>
                        <span class="tag" vid="60">Cold</span>
                    </label>
                    <label
                        style="display: flex; align-items: center; gap: 10px; font-size: 0.9rem; font-weight: 400; text-transform: none; cursor: pointer; padding: 8px; border-radius: var(--radius-sm); background: var(--surface-dark);"
                        vid="61">
                        <input type="checkbox" style="width: 16px; height: 16px; accent-color: var(--accent-red);"
                            vid="62">
                        <span style="flex: 1;" vid="63">3x Paper Goods</span>
                    </label>
                </div>
            </div>

            <button class="btn-primary" style="margin-top: 12px;" vid="64">
                Import Selected Items
            </button>
        </div>

        <div class="form-grid" vid="65">
            <div class="form-group full" vid="66">
                <label vid="67">Customer Name / Business</label>
                <input type="text" placeholder="Enter recipient name" vid="68" [(ngModel)]="activeDelivery.name">
            </div>
            <div class="form-group full" vid="69">
                <label vid="70">Full Address</label>
                <textarea placeholder="Street address, Apt, City, Zip" vid="71"></textarea>
            </div>
            <div class="form-group" vid="72">
                <label vid="73">Time Window</label>
                <input type="text" placeholder="e.g., 09:00 - 11:30" vid="74">
            </div>
            <div class="form-group" vid="75">
                <label vid="76">Contact Phone</label>
                <input type="text" placeholder="(555) 000-0000" vid="77" [(ngModel)]="activeDelivery.phone">
            </div>

            <div class="form-group full" vid="78">
                <div class="card-divider" style="margin: 12px 0;" vid="79"></div>
            </div>

            <div class="form-group full" vid="80">
                <label vid="81">Packages / Items</label>
                <div class="item-list">
                    <div class="item-row" vid="83">
                        <input type="text" placeholder="Item description (e.g., Medium Box)" vid="84"
                            [(ngModel)]="activeItem.name">
                        <input type="number" placeholder="Qty" value="1" vid="85" [(ngModel)]="activeItem.quantity">
                    </div>
                    <button class="btn-secondary" style="width: max-content; margin-top: 4px;" vid="86"
                        (click)="addItem()">
                        <svg class="icon" viewBox="0 0 24 24" vid="87">
                            <line x1="12" y1="5" x2="12" y2="19" vid="88"></line>
                            <line x1="5" y1="12" x2="19" y2="12" vid="89"></line>
                        </svg>
                        Add Item
                    </button>
                </div>

                <div class="item-list" vid="82">
                    <div class="item-row" vid="83" *ngFor="let item of activeDelivery.items; let i = index;">
                        <span>{{ item.name }}</span>
                        <span>{{ item.quantity}}</span>


                        <button class="btn-secondary" style="width: max-content; margin-top: 4px;" vid="86"
                            (click)="removeItem(i)">
                            <svg class="icon" viewBox="0 0 24 24" vid="87">
                                <line x1="12" y1="5" x2="12" y2="19" vid="88"></line>
                                <line x1="5" y1="12" x2="19" y2="12" vid="89"></line>
                            </svg>
                            Remove Item
                        </button>
                    </div>

                </div>

            </div>

            <div class="form-group full" vid="90">
                <label vid="91">Special Instructions</label>
                <textarea placeholder="e.g., Leave at back door, gate code 1234" vid="92"
                    [(ngModel)]="activeDelivery.instructions"></textarea>
            </div>

            <div class="form-group full" style="margin-top: 8px;" vid="93">
                <button class="btn-secondary"
                    style="width: 100%; justify-content: center; background: var(--bg-black); border-color: var(--text-dark);"
                    vid="94" (click)="addStop()">
                    Add Stop to Route
                </button>
            </div>
        </div>
    </div>
</div>


<div class="pane-summary" vid="95">
    <div class="summary-header" vid="96">
        <div vid="97">
            <h1 class="serif-title" style="font-size: 1.5rem;" vid="98">Itinerary</h1>
            <div class="time-window" style="margin-top: 4px;" vid="99">Est. 4 hr, 10 min, 59 sec</div>
        </div>
        <div class="text-muted" style="font-size: 0.85rem;" vid="100">{{ route.deliveries.length }} Stops</div>
    </div>

    <div class="summary-content" vid="101">
        <div class="timeline" vid="102">


            <div class="timeline-item" vid="103" *ngFor="let delivery of route.deliveries; let i = index">
                <div class="stop-badge" vid="104">
                    <div class="badge-top" vid="105">Stop</div>
                    <div class="badge-bottom" vid="106">{{ i }}</div>
                </div>
                <div class="route-card active" vid="107">
                    <div class="card-header" vid="108">
                        <div vid="109">
                            <div class="customer-name" vid="110">{{ delivery.name }}</div>
                            <div class="time-window" vid="111">07:45 – 08:15 (Morning)</div>
                        </div>
                        <div class="icon-box" vid="112"></div>
                    </div>
                    <div class="card-divider" vid="113"></div>
                    <div class="address" vid="114">{{ delivery.address.line1 }}<br vid="115">Unit B, Loading Dock</div>
                    <div class="package-info" vid="116" *ngFor="let item of delivery.items">
                        <span vid="117">{{ item.quantity }}x {{ item.name }}</span>
                        <span class="tag" vid="118">Fragile</span>
                    </div>
                </div>
            </div>



        </div>
    </div>

    <div class="summary-actions" vid="151">
        <button class="btn-secondary" style="flex: 1; justify-content: center;" vid="152">Save Draft</button>
        <button class="btn-primary" style="flex: 2;" vid="153">Start Route Delivery</button>
    </div>
</div>